import { render, staticRenderFns } from "./SchoolMenu.vue?vue&type=template&id=b2e10f1e"
import script from "./SchoolMenu.vue?vue&type=script&lang=js"
export * from "./SchoolMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports